// NO jQuery!
const btn = document.querySelector('[data-nav-btn]');

if (btn) {
    // initial btn state (closed)
    btn.setAttribute('aria-expanded', false);

    btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true' || false;
        const menu = document.querySelector(btn.dataset.navBtn);
        if (menu && expanded) {
            // was open, now closing
            btn.classList.remove('is-active');
            menu.setAttribute('hidden', true);
            document.body.classList.remove('is-nav-open');
        } else {
            // was closed, now opening
            btn.classList.add('is-active');
            menu.removeAttribute('hidden');
            document.body.classList.add('is-nav-open');
        }

        // toggle expanded
        btn.setAttribute('aria-expanded', !expanded);
    });
}
